<template>
    <tr
        class="kgr-table__row row-top"
    >
        <td :data-order="member.fullName()">
            <div class="kgr-postfix  kgr-postfix--center kgr-postfix--gutters kgr-row relation-row animated fadeIn">
                <div class="kgr-postfix__fixed">
                    <kgr-profile-image
                        :src="memberAvatarUrl"
                        :alt="member.fullName()"
                    />
                </div>
            </div>
        </td>
        <td :data-order="member.firstName">
            <div class="kgr-postfix kgr-postfix--center kgr-postfix--gutters">
                <div class="kgr-postfix__fluid">
                    <a
                        :href="memberUrl"
                        class="kgr-link kgr-link--unobtrusive"
                    >
                        {{ member.firstName }}
                    </a>
                </div>
            </div>
        </td>
        <td :data-order="member.lastName">
            <div class="kgr-postfix kgr-postfix--center kgr-postfix--gutters">
                <div class="kgr-postfix__fluid">
                    <a
                        :href="memberUrl"
                        class="kgr-link kgr-link--unobtrusive"
                    >
                        {{ member.lastName }}
                    </a>
                </div>
            </div>
        </td>
        <td :data-order="convertDateOfBirth(member.dateOfBirth)">
            {{ member.dateOfBirth }}
        </td>
        <td :data-order="member.contractState.status">
            <div class="kgr-postfix kgr-postfix--center kgr-postfix--gutters">
                <div class="kgr-postfix__fixed">
                    <kgr-member-contract-state-icon :state="getMemberContractState(member.contractState)" />
                </div>
                <kgr-member-dunning-icon v-if="member.isDunningActive" />
            </div>
        </td>
        <td>
            {{ member.membershipNumber }}
        </td>
        <td>
            {{ member.comment }}
        </td>
        <td>
            <kgr-member-attendance-action
                :is-current-day="isCurrentDay"
                :attendances="attendances"
                :member="member"
                :pending-actions="pendingActions"
                :attendance-in-edit-mode="attendanceInEditMode"
                :pending-attendances="pendingAttendances"
                :can-create-or-edit-attendances="attendancesByMember.canAttendanceBeCreatedOrEdited"
                @cancelEdit="$emit('cancelEdit')"
                @actionTriggered="$emit('actionTriggered', member.id)"
                @editAttendance="$emit('editAttendance', $event)"
                @attendanceUpdated="onAttendanceUpdated($event)"
                @attendanceRemoved="onAttendanceRemoved($event)"
            />
        </td>
    </tr>
</template>

<script>
import KgrMemberAttendanceAction from './MemberAttendanceAction.vue';
import KgrMemberContractStateIcon from '../MemberContractStateIcon.vue';
import KgrMemberDunningIcon from '../MemberDunningIcon.vue';
import MemberContractState from '../../../js/dto/MemberContractState.js';
import ProfileImage from '../../common/ProfileImage.vue';
import UrlMixin from '../UrlMixin.vue';
import moment from 'moment';

export default {
    name: 'KgrMemberAttendancesRow',
    components: {
        KgrMemberAttendanceAction,
        KgrMemberDunningIcon,
        KgrMemberContractStateIcon,
        'kgr-profile-image': ProfileImage,
    },
    mixins: [UrlMixin],
    props: {
        attendancesByMember: {
            type: Object,
            required: true,
        },
        isCurrentDay: {
            type: Boolean,
            required: true,
        },
        pendingActions: {
            type: Array,
            required: true,
        },
        attendanceInEditMode: {
            type: String,
            required: false,
            default: '',
        },
        pendingAttendances: {
            type: Array,
            required: true,
        },
    },
    computed: {
        member() {
            return this.attendancesByMember.member;
        },
        attendances() {
            return this.attendancesByMember.attendances;
        },
        memberAvatarUrl() {
            return this.avatarUrl(this.member.id, this.member.hasAvatar, this.member.gender, this.member.avatarFileName);
        },
        memberUrl() {
            return this.urlForMember(this.member.id);
        },
    },
    methods: {
        onAttendanceUpdated(event) {
            event.memberId = this.member.id;
            this.$emit('attendanceUpdated', event);
        },
        onAttendanceRemoved(event) {
            event.memberId = this.member.id;
            this.$emit('attendanceRemoved', event);
        },
        getMemberContractState(data) {
            return new MemberContractState(data.status, data.contractType);
        },
        convertDateOfBirth(dateOfBirth) {
            if (!dateOfBirth || !new RegExp('\\d{2}\\.\\d{2}.\\d{4}').test(dateOfBirth)) {
                return dateOfBirth;
            }
            return moment(dateOfBirth, 'DD.MM.YYYY').format('YYYY-MM-DD');
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .row-top {
    vertical-align: top;

    & > td {
        padding-left: 5px;
        padding-top: 10px;
    }
}
</style>
